import Achievements1 from "../Assets/Achievements1.jpg";
import Achievements2 from "../Assets/Achievements2.webp";
import Achievements3 from "../Assets/Achievements3.webp";
import Achievements4 from "../Assets/Achievements4.webp";
import Achievements5 from "../Assets/Achievements5.webp";

const achievements = [
  {
    name: "Shreyash Choppawar, Amit Prasad & Vedansh Shrivastav",
    description:
      "Second Runner-up at Innovate for Smart Pimpri Chinchwad, innovation Challenge organised by PCSCL, PCMC & PCCOE, Pune.",
    img: Achievements1,
    align: 0,
    delay: "1000",
  },
  {
    name: " Dibyanshu Sharma",
    description:
      "First Position at Techtatva Electronics Competition Organised by EnTC Dept, DYPCOE, Pune.",
    img: Achievements2,
    align: 1,
    delay: "1000",
  },
  {
    name: "Samiksha Bhokare & Sagar Warungase",
    description:
      "Second Position at Techtatva Electronics Competition Organised by EnTC Dept, DYPCOE, Pune.",
    img: Achievements3,
    align: 0,
    delay: "1000",
  },
  {
    name: "Arvind Patel",
    description:
      "Second Runner-up at COEP Mindspark-19 Search & Destroy, organised by COEP, Pune.",
    img: Achievements4,
    align: 1,
    delay: "1000",
  },
  {
    name: "Arvind Patel",
    description:
      " First Position at Bro Code & Code Capture Competition organised by PCCOE, Ravet.",
    img: Achievements5,
    align: 0,
    delay: "1000",
  },
];

export default achievements;
